var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEspecialista(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Especialista",
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8139",
    "data-name": "Grupo 8139",
    transform: "translate(-305.205 -38.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6192",
    "data-name": "Grupo 6192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_789",
    "data-name": "Trazado 789",
    d: "M343.91,231a10.054,10.054,0,0,0-.949,14.356,118.7,118.7,0,0,0,175.485,1.763,10.015,10.015,0,0,0-1.278-14.731l-85.447-65.813a10.033,10.033,0,0,0-12.632.315Z",
    fill: "#655dc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_790",
    "data-name": "Trazado 790",
    d: "M419.089,167.886l-73.7,62.852c22.316,23.662,54.119,40.075,89.08,39.2,31.975-.8,60.672-16.231,81.5-37.486l-84.243-64.885A10.033,10.033,0,0,0,419.089,167.886Z",
    fill: "#524ba4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_206",
    "data-name": "Elipse 206",
    cx: 99.071,
    cy: 99.071,
    r: 99.071,
    transform: "translate(330.405 55.035)",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_207",
    "data-name": "Elipse 207",
    cx: 89.464,
    cy: 89.464,
    r: 89.464,
    transform: "translate(340.012 64.643)",
    fill: "#fc9a05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6193",
    "data-name": "Grupo 6193"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_208",
    "data-name": "Elipse 208",
    cx: 80.801,
    cy: 80.801,
    r: 80.801,
    transform: "translate(315.205 154.106) rotate(-45)",
    fill: "#02daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_791",
    "data-name": "Trazado 791",
    d: "M429.476,236.407a82.3,82.3,0,1,1,82.3-82.3A82.395,82.395,0,0,1,429.476,236.407Zm0-161.6a79.3,79.3,0,1,0,79.3,79.3A79.391,79.391,0,0,0,429.476,74.805Z",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6209",
    "data-name": "Grupo 6209",
    transform: "translate(14 -5.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6207",
    "data-name": "Grupo 6207"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_220",
    "data-name": "Elipse 220",
    cx: 2.684,
    cy: 2.684,
    r: 2.684,
    transform: "translate(356.226 147.991)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6208",
    "data-name": "Grupo 6208"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_221",
    "data-name": "Elipse 221",
    cx: 1.684,
    cy: 1.684,
    r: 1.684,
    transform: "translate(361.967 159.127)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8132",
    "data-name": "Grupo 8132",
    transform: "translate(0 8.452)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_220-2",
    "data-name": "Elipse 220",
    cx: 1.342,
    cy: 1.342,
    r: 1.342,
    transform: "translate(356.226 147.991)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7398",
    "data-name": "Grupo 7398",
    transform: "translate(-113.094 -752.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7314",
    "data-name": "Grupo 7314",
    transform: "translate(467.479 844.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7304",
    "data-name": "Grupo 7304",
    transform: "translate(1.099 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2493",
    "data-name": "Trazado 2493",
    d: "M888.084,1325.969c-.111,7.235-2.308,16.329-13.524,11.75-17.647-7.2-23.519-21.527-23.519-21.527a16.37,16.37,0,0,1-7.877-8.367,4.2,4.2,0,0,1-2.653-.051,4.471,4.471,0,0,1-2.58-3.153c-1.423-4.572,1.524-6.2,1.524-6.2.458-4.421,3.2-3.861,3.2-3.861-2.64-9.1.7-9.505,1.881-9.2,1.575.408,3.406,6.2,3.406,6.2s-.661-5.692,1.17-7.371a1.717,1.717,0,0,1,2.21-.4,2.21,2.21,0,0,1,.964,1.382,53.446,53.446,0,0,0,3.26,9.2c.683,1.492,1.382,2.849,2.046,4.051a48.021,48.021,0,0,0,3.817,5.948c8.778,6.918,15.842,10.444,20.4,12.215a9.786,9.786,0,0,1,5.091,4.512A9.909,9.909,0,0,1,888.084,1325.969Z",
    transform: "translate(-837.543 -1283.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7305",
    "data-name": "Grupo 7305",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2494",
    "data-name": "Trazado 2494",
    d: "M863.793,1323.777a15.628,15.628,0,0,1-5.826-1.316c-16.426-6.7-22.828-19.275-23.947-21.731a17.377,17.377,0,0,1-7.681-7.923,5.014,5.014,0,0,1-2.818-.466,5.755,5.755,0,0,1-2.821-3.673c-1.175-3.775.295-6.152,1.546-7.158a5.343,5.343,0,0,1,1.895-3.686,3.471,3.471,0,0,1,.938-.491c-1.078-4.245-.911-7.028.5-8.485a3.171,3.171,0,0,1,3.058-.84,4.2,4.2,0,0,1,2.138,2.077,5.422,5.422,0,0,1,1.411-2.99,2.828,2.828,0,0,1,3.533-.531,3.309,3.309,0,0,1,1.466,2.059,55.737,55.737,0,0,0,8.84,18.678c8.715,6.855,15.687,10.291,20.007,11.967a11.034,11.034,0,0,1,6.984,10.436c-.1,6.475-1.708,10.787-4.779,12.817A7.892,7.892,0,0,1,863.793,1323.777Zm-36.808-33.341a1.112,1.112,0,0,1,1.045.72,15.375,15.375,0,0,0,7.3,7.746,1.106,1.106,0,0,1,.563.586c.057.138,5.937,14,22.911,20.923,3.532,1.441,6.3,1.529,8.215.261,3.02-2,3.726-7.086,3.787-11a8.813,8.813,0,0,0-5.571-8.338h0c-4.479-1.738-11.7-5.3-20.684-12.377a1.111,1.111,0,0,1-.183-.183,56.855,56.855,0,0,1-9.326-19.61,1.136,1.136,0,0,0-.468-.706c-.134-.081-.357-.216-.889.27-.971.89-1.063,4.294-.817,6.426a1.107,1.107,0,0,1-2.155.461c-.82-2.594-2.053-5.133-2.652-5.468a.957.957,0,0,0-.891.244c-.33.34-1.277,1.891.376,7.58a1.106,1.106,0,0,1-.241,1.086,1.06,1.06,0,0,1-1.043.307s-.024,0-.072,0a1.269,1.269,0,0,0-.77.272,3.8,3.8,0,0,0-1.038,2.622,1.107,1.107,0,0,1-.566.855c-.206.122-2.1,1.367-1,4.9a3.678,3.678,0,0,0,1.674,2.339,3.054,3.054,0,0,0,2.137.147A1.113,1.113,0,0,1,826.984,1290.436Z",
    transform: "translate(-820.269 -1266.159)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7306",
    "data-name": "Grupo 7306",
    transform: "translate(3.751 11.395)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2495",
    "data-name": "Trazado 2495",
    d: "M927.1,1477.324c-.111,7.235-2.308,16.329-13.524,11.75-17.647-7.2-23.519-21.527-23.519-21.527a16.369,16.369,0,0,1-7.877-8.367,4.2,4.2,0,0,1-2.653-.051,7.1,7.1,0,0,1,.5-5.4,8.742,8.742,0,0,1,2.15-6.428c3.93-2.618,8.809-2.34,12.383-1.571.683,1.492,1.382,2.849,2.046,4.051a24.663,24.663,0,0,0-11.835-1.54c-6.236,3.523,1.663,6.858,1.663,6.858l5.856,2.356c-6.719-.468-8.481,4.705-2.236,5.489s10.368-7.216,10.368-7.216c.136,6-5.9,10.365-5.9,10.365a40.786,40.786,0,0,0,6.193,8.835,11.908,11.908,0,0,0,16.29.983c3.824-3.134,7.2-3.516,8.91-3.456A9.907,9.907,0,0,1,927.1,1477.324Z",
    transform: "translate(-879.211 -1445.193)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7313",
    "data-name": "Grupo 7313",
    transform: "translate(1.936 8.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7307",
    "data-name": "Grupo 7307",
    transform: "translate(12.52 12.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2496",
    "data-name": "Trazado 2496",
    d: "M1047.69,1622.936l-.284-2.2c8.93-1.154,9.388-10.377,9.4-10.769l2.212.085C1059.016,1610.172,1058.453,1621.545,1047.69,1622.936Z",
    transform: "translate(-1047.406 -1609.972)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7308",
    "data-name": "Grupo 7308",
    transform: "translate(3.978 3.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2497",
    "data-name": "Trazado 2497",
    d: "M928.306,1471.777a38.846,38.846,0,0,0-6.537-2,13.5,13.5,0,0,0-3.214-.272,3.9,3.9,0,0,0-2.471.868,1.793,1.793,0,0,0-.524.853,1.217,1.217,0,0,0,.22.9,4.772,4.772,0,0,0,.953,1.077,13.021,13.021,0,0,0,1.315.974c1.883,1.242,3.983,2.319,6.06,3.629a15.577,15.577,0,0,1-3.63-.553,16.415,16.415,0,0,1-3.459-1.341,11.873,11.873,0,0,1-1.634-1.038,6.943,6.943,0,0,1-1.495-1.505,4.1,4.1,0,0,1-.553-1.1,4.881,4.881,0,0,1-.141-.664,4.352,4.352,0,0,1,.011-.7,3.638,3.638,0,0,1,.419-1.263,4.831,4.831,0,0,1,.716-.98,5.116,5.116,0,0,1,1.948-1.259,7.6,7.6,0,0,1,2.082-.436,14.143,14.143,0,0,1,3.889.3,24.6,24.6,0,0,1,3.594,1.024,27.84,27.84,0,0,1,3.4,1.483Z",
    transform: "translate(-913.189 -1466.94)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7309",
    "data-name": "Grupo 7309",
    transform: "translate(0 6.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2498",
    "data-name": "Trazado 2498",
    d: "M856.834,1521.348a3.651,3.651,0,0,1-.973-.133c-3.47-.953-5.007-6.9-5.171-7.581l2.151-.522h0c.5,2.064,1.928,5.508,3.608,5.968.708.2,1.546-.2,2.491-1.164l1.583,1.548A5.281,5.281,0,0,1,856.834,1521.348Z",
    transform: "translate(-850.69 -1513.112)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7310",
    "data-name": "Grupo 7310",
    transform: "translate(4.253 13.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2499",
    "data-name": "Trazado 2499",
    d: "M918.54,1626.093l-1-1.973-.031.017c.1-.06.593-.414.455-1.443l2.194-.295A3.486,3.486,0,0,1,918.54,1626.093Z",
    transform: "translate(-917.506 -1622.399)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7311",
    "data-name": "Grupo 7311",
    transform: "translate(3.206 2.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2500",
    "data-name": "Trazado 2500",
    d: "M902.745,1456.388a15.541,15.541,0,0,1-1.684-3.712l2.141-.561a13.708,13.708,0,0,0,1.44,3.131Z",
    transform: "translate(-901.061 -1452.116)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7312",
    "data-name": "Grupo 7312",
    transform: "translate(8.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2501",
    "data-name": "Trazado 2501",
    d: "M984.934,1412.609a27.636,27.636,0,0,1-1.236-5.216l2.193-.3a25.877,25.877,0,0,0,1.1,4.708Z",
    transform: "translate(-983.698 -1407.096)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7318",
    "data-name": "Grupo 7318",
    transform: "translate(543.255 874.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7315",
    "data-name": "Grupo 7315",
    transform: "translate(1.107 1.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2502",
    "data-name": "Trazado 2502",
    d: "M2074.029,1769.521c-3.342,38.476-18.763,59.4-25.656,66.965a5.765,5.765,0,0,1-7.172,1.081l-5.271-3.077-7.69-3.7,2.435-5.749,26.552-62.728a23.569,23.569,0,0,1,8.494,1.037C2071.844,1765.37,2074.029,1769.521,2074.029,1769.521Z",
    transform: "translate(-2028.24 -1762.287)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7316",
    "data-name": "Grupo 7316",
    transform: "translate(3.541 1.125)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2503",
    "data-name": "Trazado 2503",
    d: "M2074.595,1830.209l-2.893-2.172-5.207-2.716,26.552-62.728.1,0a9.047,9.047,0,0,1,9.363,8.4c1.813,24.358-10.057,46.591-16.955,57.266A7.61,7.61,0,0,1,2074.595,1830.209Z",
    transform: "translate(-2066.495 -1762.579)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7317",
    "data-name": "Grupo 7317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2504",
    "data-name": "Trazado 2504",
    d: "M2027.827,1823.181a6.86,6.86,0,0,1-3.464-.934l-5.231-3.056-7.651-3.677a1.107,1.107,0,0,1-.54-1.429l28.985-68.474a1.106,1.106,0,0,1,.968-.674c13.255-.613,17.653,7.448,17.834,7.791a1.107,1.107,0,0,1,.124.612c-3.392,39.044-19.271,60.292-25.94,67.615A6.872,6.872,0,0,1,2027.827,1823.181Zm-14.436-9.206,6.74,3.24q.04.02.079.042l5.269,3.078a4.68,4.68,0,0,0,5.8-.873c6.5-7.135,21.943-27.817,25.341-65.964-.807-1.269-4.8-6.611-14.927-6.376Z",
    transform: "translate(-2010.853 -1744.903)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7332",
    "data-name": "Grupo 7332",
    transform: "translate(443.499 868.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7319",
    "data-name": "Grupo 7319",
    transform: "translate(1.091 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2505",
    "data-name": "Trazado 2505",
    d: "M629.239,1667.32c1.217,23.073-12.705,21.141-12.705,21.141-7.32,6.757-25.786,8.639-25.786,8.639-5.357,19.719-14.767,37.132-28.183,46.077s-21.208,25.679-22.09,31.1-9.824,8.471-12.806,6.381-22.359-12.749-27.171-15.054-4.471-5.217-4.471-5.217a19.523,19.523,0,0,1,1.338-5.749c4.9-11.759,20.48-6.21,20.48-6.21,5.284-12.2,10.874-18.7,10.874-18.7-.914-.509-2.473-1.322-2.473-1.322-9.891.408-25.34,8.809-29.679,14.773a14.927,14.927,0,0,1-7.393,5.524,9.412,9.412,0,0,1-3.494.456,5.559,5.559,0,0,1-3.883-1.78c-3.118-3.523-12.468-8.809-18.023-13.957s-2.033-10.571-2.033-10.571a27.817,27.817,0,0,1,1.923-2.131c10.691-10.647,19.623.1,19.623.1,21.277-18.159,33.948-14.365,33.948-14.365,3.456-20.733,13.005-31.51,13.005-31.51v0c16.458-10.783,48.079-3.45,48.079-3.45s5.584.73,12.553.952c6.451.2,14.093-.038,19.6-1.7,11.45-3.453,13.552-11.652,17.141-10.536,3.532,1.1,1.692,6.918,1.632,7.115Z",
    transform: "translate(-460.639 -1660.102)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7320",
    "data-name": "Grupo 7320",
    transform: "translate(36.473 8.333)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2506",
    "data-name": "Trazado 2506",
    d: "M1137.064,1794.653c-7.32,6.757-25.786,8.639-25.786,8.639-5.356,19.718-14.767,37.132-28.183,46.077s-21.208,25.679-22.09,31.1-9.824,8.471-12.806,6.381-22.359-12.749-27.171-15.054-4.471-5.217-4.471-5.217a19.524,19.524,0,0,1,1.338-5.749,39.842,39.842,0,0,0,19.066,11.4,21.909,21.909,0,0,0,24.445-10.39c2.7-4.717,5.357-8.771,7.739-12.121,5.5-7.74,4.194-19.829-5.665-23.048-16.54-5.4-18.464-9.012-18.464-9.012l31.914,5.252.971-6.5,9.772,2.505a9.633,9.633,0,0,0,11.106-5.156,27.574,27.574,0,0,0,2.631-10.583,9,9,0,0,0-9.894-9.331c-33.551,3.215-40.614-12.415-40.746-12.708v0c16.458-10.782,48.079-3.45,48.079-3.45s5.584.73,12.553.952c2.418,3.64,2.244,8.811,1.726,12.338a3.67,3.67,0,0,0,3.705,4.215,40.943,40.943,0,0,0,14.492-3.386l2.942-.984a5.385,5.385,0,0,0,3.656-4.509c0-.025,0-.038,0-.038-.964-1.066-.051-3.358-.051-3.358-.408-9.2,11.892-9.4,11.892-9.4C1150.986,1796.585,1137.064,1794.653,1137.064,1794.653Z",
    transform: "translate(-1016.551 -1773.512)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7321",
    "data-name": "Grupo 7321",
    transform: "translate(1.091 55.998)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2507",
    "data-name": "Trazado 2507",
    d: "M538.713,2529.2c-4.743,2.1-10,7.962-10,7.962-.914-.51-2.473-1.322-2.473-1.322-9.891.408-25.34,8.81-29.679,14.773a14.926,14.926,0,0,1-7.393,5.524,9.4,9.4,0,0,1-3.494.455,5.558,5.558,0,0,1-3.883-1.78c-3.118-3.523-12.468-8.81-18.023-13.957s-2.033-10.571-2.033-10.571a27.814,27.814,0,0,1,1.923-2.131c.177,6.71,7.428,11.776,14.154,15.042a15.781,15.781,0,0,0,16.936-1.905c6.586-5.441,15.165-8,20.092-9.1a4.456,4.456,0,0,0,3.476-4.537,17.245,17.245,0,0,1,.359-4.474.984.984,0,0,1,1.764-.341,45.914,45.914,0,0,0,6.073,6.976,3.566,3.566,0,0,0,3.807.685A19.644,19.644,0,0,1,538.713,2529.2Z",
    transform: "translate(-460.639 -2522.424)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7322",
    "data-name": "Grupo 7322",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2508",
    "data-name": "Trazado 2508",
    d: "M514.269,1766.032a5.726,5.726,0,0,1-3.285-.863c-2.872-2.013-22.3-12.7-27.014-14.961-5.461-2.615-5.111-6.193-5.093-6.344.518-5.628,2.636-9.678,6.292-12.012,5.685-3.63,13.309-1.947,16.011-1.172a85.254,85.254,0,0,1,9.8-17.006c-.4-.215-.786-.416-1.028-.544-9.608.544-24.371,8.575-28.536,14.3-2.758,3.793-6.887,6.264-10.774,6.45a6.982,6.982,0,0,1-5.721-2.166c-1.5-1.695-4.7-3.942-8.081-6.322a98.706,98.706,0,0,1-9.866-7.558c-6.168-5.717-2.249-11.923-2.208-11.985a1.191,1.191,0,0,1,.071-.1c3.914-4.788,8.124-7.226,12.515-7.244h.05c4.815,0,8.418,2.924,9.923,4.392,17.574-14.7,29.291-14.649,32.964-14.145,3.611-20.078,12.682-30.506,13.073-30.948a1.1,1.1,0,0,1,.222-.192c16.476-10.792,46.932-4.059,48.881-3.613,1.151.145,20.82,2.55,31.636-.714a26.751,26.751,0,0,0,11.955-7.595c2.033-2.025,3.637-3.624,5.836-2.94a3.871,3.871,0,0,1,2.34,1.958c1.159,2.246.34,5.456.073,6.355.447,9.042-1.333,15.47-5.292,19.106a11.49,11.49,0,0,1-8.141,3.033c-6.9,5.968-21.737,8.083-25.3,8.516-5.935,21.388-16.018,37.7-28.439,45.981-13.14,8.76-20.783,25.266-21.611,30.357-.459,2.824-2.852,5.4-6.4,6.9A12.748,12.748,0,0,1,514.269,1766.032Zm-20.5-34.2a13.715,13.715,0,0,0-7.412,1.887c-3.045,1.948-4.819,5.437-5.274,10.372-.005.088-.089,2.233,3.848,4.118,4.9,2.348,24.311,13.03,27.328,15.145,1.082.759,3.607.576,6-.434,2.843-1.2,4.741-3.15,5.077-5.217.9-5.544,8.674-22.582,22.567-31.844,12.115-8.077,21.963-24.216,27.73-45.445a1.107,1.107,0,0,1,.956-.811c.181-.018,18.186-1.923,25.146-8.351a1.1,1.1,0,0,1,.9-.283,9.117,9.117,0,0,0,6.911-2.458c3.407-3.158,4.976-9.219,4.537-17.528a1.1,1.1,0,0,1,.053-.4c.283-.871.858-3.446.126-4.858a1.637,1.637,0,0,0-1.029-.856c-.882-.275-1.847.632-3.617,2.395a29.068,29.068,0,0,1-12.877,8.145c-11.546,3.485-31.759.9-32.615.783-.036,0-.071-.011-.106-.019-.311-.072-31.182-7.061-47.092,3.21-.975,1.167-9.473,11.792-12.651,30.857a1.107,1.107,0,0,1-1.409.878c-.117-.033-12.46-3.309-32.911,14.146a1.107,1.107,0,0,1-1.57-.134c-.036-.043-3.754-4.406-8.989-4.406h-.058c-3.676.023-7.291,2.168-10.747,6.377-.3.5-2.7,4.861,1.883,9.113a95.7,95.7,0,0,0,9.634,7.371c3.646,2.563,6.8,4.776,8.467,6.666a4.849,4.849,0,0,0,3.958,1.422c3.184-.152,6.752-2.327,9.089-5.541,4.573-6.288,20.2-14.8,30.527-15.226a1.1,1.1,0,0,1,.557.125c.064.034,1.582.826,2.5,1.335a1.107,1.107,0,0,1,.3,1.688c-.055.064-5.553,6.545-10.7,18.42a1.106,1.106,0,0,1-1.387.6A25.946,25.946,0,0,0,493.765,1731.834Z",
    transform: "translate(-443.499 -1642.593)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7331",
    "data-name": "Grupo 7331",
    transform: "translate(21.097 10.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7323",
    "data-name": "Grupo 7323",
    transform: "translate(0 50.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2509",
    "data-name": "Trazado 2509",
    d: "M778.385,2603.183c-.249.185-.52.375-.8.55s-.558.351-.843.524-.573.344-.872.509-.592.339-.907.505a7.935,7.935,0,0,1,.347-.994c.131-.324.283-.635.438-.943s.325-.6.5-.894a8.323,8.323,0,0,1,.58-.84Z",
    transform: "translate(-774.968 -2601.602)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7324",
    "data-name": "Grupo 7324",
    transform: "translate(8.786 45.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2510",
    "data-name": "Trazado 2510",
    d: "M927.756,2547.2c-15.126-8.823-14.755-21.583-14.732-22.121l2.211.092c-.018.486-.288,12,13.635,20.117Z",
    transform: "translate(-913.02 -2525.075)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7325",
    "data-name": "Grupo 7325",
    transform: "translate(40.197 50.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2511",
    "data-name": "Trazado 2511",
    d: "M1411.267,2617.507c-.117-.1-.188-.168-.273-.25s-.159-.159-.235-.238c-.152-.16-.3-.321-.439-.485a12.747,12.747,0,0,1-.792-1.01,18.415,18.415,0,0,1-1.337-2.144,19,19,0,0,1-1.019-2.279c-.151-.385-.258-.788-.374-1.183s-.184-.808-.258-1.213l1.4,2c.456.656.94,1.283,1.438,1.89s1.03,1.178,1.576,1.719c.272.271.559.526.839.778.141.125.285.246.427.36l.213.168c.066.052.149.115.189.141Z",
    transform: "translate(-1406.541 -2608.704)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7326",
    "data-name": "Grupo 7326",
    transform: "translate(47.202 51.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2512",
    "data-name": "Trazado 2512",
    d: "M1516.593,2636.211a15.421,15.421,0,0,1,1.09-1.305c.374-.412.772-.8,1.172-1.182s.826-.739,1.252-1.094.869-.687,1.323-1.006a20.306,20.306,0,0,1,2.843-1.718q.378-.177.76-.339c.264-.093.525-.189.79-.275l.4-.124c.135-.037.274-.062.411-.094.273-.061.55-.11.828-.146-.816.789-1.647,1.438-2.445,2.135-.206.163-.4.338-.6.507s-.406.33-.6.5c-.394.344-.785.689-1.164,1.049s-.757.716-1.129,1.08l-.554.549c-.181.187-.358.377-.542.56-.361.374-.713.754-1.065,1.133l-1.018,1.128Z",
    transform: "translate(-1516.593 -2628.931)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7327",
    "data-name": "Grupo 7327",
    transform: "translate(35.633 78.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2513",
    "data-name": "Trazado 2513",
    d: "M1337.434,3042.744c-.162.373-.344.754-.538,1.126s-.4.745-.6,1.115a24.706,24.706,0,0,1-1.375,2.215,10.668,10.668,0,0,1-.019-2.649c.042-.433.1-.863.171-1.288a11.859,11.859,0,0,1,.28-1.263Z",
    transform: "translate(-1334.826 -3042)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7328",
    "data-name": "Grupo 7328",
    transform: "translate(40.025 70.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2514",
    "data-name": "Trazado 2514",
    d: "M1432.181,2934.287a34.284,34.284,0,0,1-21.707-8.626,31.173,31.173,0,0,1-6.64-8.075l1.967-1.016-.983.508.983-.509a32.123,32.123,0,0,0,26.471,15.507Z",
    transform: "translate(-1403.834 -2916.569)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7329",
    "data-name": "Grupo 7329",
    transform: "translate(126.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2515",
    "data-name": "Trazado 2515",
    d: "M2768.943,1834.806c-2.279,0-6.545-1.494-8.5-7.353-2.521-7.544,1.732-12.062,1.914-12.251l1.6,1.534c-.144.151-3.491,3.79-1.41,10.016,2.017,6.035,6.414,5.848,6.6,5.834l.158,2.208C2769.185,1834.8,2769.067,1834.806,2768.943,1834.806Z",
    transform: "translate(-2759.643 -1815.202)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7330",
    "data-name": "Grupo 7330",
    transform: "translate(103.059 26.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2516",
    "data-name": "Trazado 2516",
    d: "M2401.449,2226.419a8.733,8.733,0,0,1-1.823.255,13.359,13.359,0,0,1-1.824-.05,11.8,11.8,0,0,1-1.815-.305,8.2,8.2,0,0,1-1.766-.629c.6-.223,1.186-.376,1.764-.529s1.148-.283,1.716-.405,1.133-.23,1.7-.324a15.093,15.093,0,0,1,1.68-.194l.043,0a1.111,1.111,0,0,1,.328,2.184Z",
    transform: "translate(-2394.22 -2224.235)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7354",
    "data-name": "Grupo 7354",
    transform: "translate(499.243 815.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7336",
    "data-name": "Grupo 7336",
    transform: "translate(0 23.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7333",
    "data-name": "Grupo 7333",
    transform: "translate(1.107 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_479",
    "data-name": "Rect\\xE1ngulo 479",
    d: "M10.7,0h2.98a0,0,0,0,1,0,0V31.282a0,0,0,0,1,0,0h0A13.676,13.676,0,0,1,0,17.606V10.7A10.7,10.7,0,0,1,10.7,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7334",
    "data-name": "Grupo 7334",
    transform: "translate(1.107 15.465)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2517",
    "data-name": "Trazado 2517",
    d: "M1336.724,1432.786v8.941a7.983,7.983,0,0,0,7.983,7.983h5.693v-8.941h-5.693A7.983,7.983,0,0,1,1336.724,1432.786Z",
    transform: "translate(-1336.724 -1432.786)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7335",
    "data-name": "Grupo 7335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2518",
    "data-name": "Trazado 2518",
    d: "M1335.226,1223.3h-6.6a9.3,9.3,0,0,1-9.293-9.293v-16.693a7.518,7.518,0,0,1,7.51-7.51h8.38Zm-8.38-31.282a5.3,5.3,0,0,0-5.3,5.3V1214a7.088,7.088,0,0,0,7.08,7.08h4.383v-29.069Z",
    transform: "translate(-1319.337 -1189.801)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7340",
    "data-name": "Grupo 7340",
    transform: "translate(74.349 23.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7337",
    "data-name": "Grupo 7337",
    transform: "translate(1.107 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_480",
    "data-name": "Rect\\xE1ngulo 480",
    d: "M13.676,0h0a0,0,0,0,1,0,0V31.282a0,0,0,0,1,0,0H10.7A10.7,10.7,0,0,1,0,20.585V13.676A13.676,13.676,0,0,1,13.676,0Z",
    transform: "translate(13.676 31.282) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7338",
    "data-name": "Grupo 7338",
    transform: "translate(1.107 15.465)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2519",
    "data-name": "Trazado 2519",
    d: "M2518.564,1432.786v8.941a7.983,7.983,0,0,1-7.982,7.983h-5.694v-8.941h5.694A7.983,7.983,0,0,0,2518.564,1432.786Z",
    transform: "translate(-2504.888 -1432.786)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7339",
    "data-name": "Grupo 7339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2520",
    "data-name": "Trazado 2520",
    d: "M2494.1,1223.3h-6.6v-33.5h8.38a7.518,7.518,0,0,1,7.51,7.51V1214A9.3,9.3,0,0,1,2494.1,1223.3Zm-4.383-2.214h4.383a7.088,7.088,0,0,0,7.08-7.08v-16.693a5.3,5.3,0,0,0-5.3-5.3h-6.167Z",
    transform: "translate(-2487.499 -1189.801)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7345",
    "data-name": "Grupo 7345",
    transform: "translate(13.839 61.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7341",
    "data-name": "Grupo 7341",
    transform: "translate(1.108 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2521",
    "data-name": "Trazado 2521",
    d: "M1614.528,1801.093v5.861s-8.281,9.425-30.172,9.425-30.172-9.425-30.172-9.425v-5.861Z",
    transform: "translate(-1554.184 -1801.093)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7342",
    "data-name": "Grupo 7342",
    transform: "translate(1.108 1.107)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2522",
    "data-name": "Trazado 2522",
    d: "M1584.356,1801.093v12.8c-21.891,0-30.172-9.845-30.172-9.845v-2.954Z",
    transform: "translate(-1554.184 -1801.093)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7343",
    "data-name": "Grupo 7343",
    transform: "translate(31.28 1.107)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2523",
    "data-name": "Trazado 2523",
    d: "M2028.245,1801.093v12.8c21.891,0,30.172-9.845,30.172-9.845v-2.954Z",
    transform: "translate(-2028.245 -1801.093)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7344",
    "data-name": "Grupo 7344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2524",
    "data-name": "Trazado 2524",
    d: "M1568.059,1801.2c-22.137,0-30.653-9.4-31-9.8a1.107,1.107,0,0,1-.275-.731V1784.8a1.106,1.106,0,0,1,1.106-1.107h60.347a1.107,1.107,0,0,1,1.107,1.107v5.861a1.107,1.107,0,0,1-.275.731C1598.712,1791.8,1590.2,1801.2,1568.059,1801.2Zm-29.067-10.986c1.586,1.522,10.139,8.772,29.067,8.772,19.01,0,27.49-7.24,29.067-8.769v-4.3h-58.134Z",
    transform: "translate(-1536.779 -1783.698)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7349",
    "data-name": "Grupo 7349",
    transform: "translate(5.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7346",
    "data-name": "Grupo 7346",
    transform: "translate(1.135 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2525",
    "data-name": "Trazado 2525",
    d: "M1463.142,904.513c49.243,0,37.082-44.612,37.082-44.612-4.477-15.674-19.055-27.106-37.082-27.106s-32.605,11.432-37.082,27.106C1426.059,859.9,1413.9,904.513,1463.142,904.513Z",
    transform: "translate(-1424.73 -832.795)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7347",
    "data-name": "Grupo 7347",
    transform: "translate(3.9 14.325)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2526",
    "data-name": "Trazado 2526",
    d: "M1540.9,1054.372a36.652,36.652,0,0,0-7.515-13.887,36.537,36.537,0,0,1,2.14,5.666s12.161,44.612-37.082,44.612c-15.254,0-24.615-4.282-30.271-10.191,4.133,9.714,13.9,18.413,35.646,18.413C1553.064,1098.984,1540.9,1054.372,1540.9,1054.372Z",
    transform: "translate(-1468.174 -1040.485)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7348",
    "data-name": "Grupo 7348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2527",
    "data-name": "Trazado 2527",
    d: "M1446.449,889.338c-15.421,0-26.542-4.323-33.056-12.85-10.3-13.481-5.311-32.363-5.094-33.16,4.772-16.706,20.1-27.921,38.15-27.921s33.378,11.215,38.146,27.908c.221.81,5.207,19.692-5.09,33.173C1472.991,885.015,1461.869,889.338,1446.449,889.338Zm0-71.718c-17.05,0-31.524,10.57-36.018,26.3-.047.172-4.906,18.632,4.729,31.232,6.074,7.942,16.6,11.969,31.289,11.969s25.215-4.027,31.288-11.969c9.636-12.6,4.776-31.061,4.726-31.245C1477.973,828.19,1463.5,817.62,1446.449,817.62Z",
    transform: "translate(-1406.902 -815.407)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7353",
    "data-name": "Grupo 7353",
    transform: "translate(11.463 18.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7350",
    "data-name": "Grupo 7350",
    transform: "translate(1.107 1.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2528",
    "data-name": "Trazado 2528",
    d: "M1549.378,1175.7c32.553,0,32.55-21.671,32.55-21.671,0-25.238-32.55-23.983-32.55-23.983s-32.55-1.255-32.55,23.983C1516.828,1154.034,1516.825,1175.7,1549.378,1175.7Z",
    transform: "translate(-1516.828 -1130.04)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7351",
    "data-name": "Grupo 7351",
    transform: "translate(1.107 1.11)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2529",
    "data-name": "Trazado 2529",
    d: "M1549.378,1130.051s-32.55-1.255-32.55,23.983a19.464,19.464,0,0,0,3.124,9.466,17.738,17.738,0,0,1-1.227-5.672c0-6.818,2.377-11.7,5.845-15.2a1.808,1.808,0,0,1,1.815-.461c2.046.644,5.521.253,9.134-1.193,3.756-1.5,6.617-3.732,7.548-5.663a1.914,1.914,0,0,1,1.483-1.094,46.847,46.847,0,0,1,6.725-.373s21.024-.807,29.277,11.979C1574.363,1129.088,1549.378,1130.051,1549.378,1130.051Z",
    transform: "translate(-1516.828 -1130.04)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7352",
    "data-name": "Grupo 7352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2530",
    "data-name": "Trazado 2530",
    d: "M1533.1,1160.485c-17.273,0-25.5-6.133-29.367-11.277a20.782,20.782,0,0,1-4.289-11.5c0-6.674,2.2-12.173,6.535-16.346,9.526-9.166,25.952-8.785,27.121-8.744,1.168-.04,17.594-.422,27.121,8.744,4.337,4.173,6.536,9.673,6.536,16.346a20.78,20.78,0,0,1-4.29,11.5C1558.6,1154.352,1550.369,1160.485,1533.1,1160.485Zm-.663-45.662c-3.087,0-16.94.446-24.929,8.139-3.882,3.739-5.851,8.7-5.851,14.745a18.934,18.934,0,0,0,3.922,10.271c5.123,6.734,14.639,10.293,27.521,10.293s22.4-3.559,27.521-10.293a18.932,18.932,0,0,0,3.922-10.273c0-6.043-1.968-11-5.851-14.743-8.984-8.652-25.384-8.139-25.55-8.132l-.042,0-.042,0C1533.036,1114.83,1532.818,1114.823,1532.433,1114.823Z",
    transform: "translate(-1499.44 -1112.605)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7370",
    "data-name": "Grupo 7370",
    transform: "translate(599.06 826.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7358",
    "data-name": "Grupo 7358",
    transform: "translate(0 2.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7355",
    "data-name": "Grupo 7355",
    transform: "translate(1.107 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2531",
    "data-name": "Trazado 2531",
    d: "M2917.474,1125.78h0a2.115,2.115,0,0,1-2.374-1.819l-10.036-75.809a2.115,2.115,0,0,1,1.819-2.374h0a2.115,2.115,0,0,1,2.374,1.819l10.037,75.809A2.115,2.115,0,0,1,2917.474,1125.78Z",
    transform: "translate(-2905.046 -1045.76)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7356",
    "data-name": "Grupo 7356",
    transform: "translate(2.925 1.107)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2532",
    "data-name": "Trazado 2532",
    d: "M2946.034,1123.406,2936,1047.6a2.114,2.114,0,0,0-2.374-1.819h0l-.02,0,9.9,74.778a2.114,2.114,0,0,1-1.8,2.37l.136,1.031a2.114,2.114,0,1,0,4.192-.555Z",
    transform: "translate(-2933.605 -1045.76)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7357",
    "data-name": "Grupo 7357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2533",
    "data-name": "Trazado 2533",
    d: "M2900.907,1110.62a3.226,3.226,0,0,1-3.191-2.8l-10.036-75.809a3.221,3.221,0,0,1,6.387-.845l10.036,75.809a3.221,3.221,0,0,1-2.771,3.616h0A3.235,3.235,0,0,1,2900.907,1110.62Zm-10.034-80.038a1.008,1.008,0,0,0-1,1.14l10.036,75.809a1.009,1.009,0,0,0,1.132.867h0a1.007,1.007,0,0,0,.866-1.131l-10.036-75.809A1.009,1.009,0,0,0,2890.873,1030.582Z",
    transform: "translate(-2887.651 -1028.368)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7359",
    "data-name": "Grupo 7359",
    transform: "translate(5.533 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2534",
    "data-name": "Trazado 2534",
    d: "M3014.564,1016.448l11.155,11.955-47.553,6.3-3.589-27.109,47.553-6.3-5.4,10.823Z",
    transform: "translate(-2974.577 -1001.294)",
    fill: "#ff0031"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7362",
    "data-name": "Grupo 7362",
    transform: "translate(5.533 1.107)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7360",
    "data-name": "Grupo 7360",
    transform: "translate(40.624 16.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2535",
    "data-name": "Trazado 2535",
    d: "M3612.849,1259.581l9.235,9.9,1.284-.17-10.016-10.734Z",
    transform: "translate(-3612.849 -1258.574)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7361",
    "data-name": "Grupo 7361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2536",
    "data-name": "Trazado 2536",
    d: "M2975.214,1009.817l45.681-6.048,1.236-2.475-47.553,6.3,3.589,27.109.335-.044Z",
    transform: "translate(-2974.578 -1001.294)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7363",
    "data-name": "Grupo 7363",
    transform: "translate(8.181 11.93)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2537",
    "data-name": "Trazado 2537",
    d: "M3064.685,1187.631l-47.553,6.3-.94-7.1c16.413.7,19.271-9.109,19.271-9.109s3.473,3.345,12.583-.119a17.788,17.788,0,0,0,7.647-6.25l-2.163,4.331Z",
    transform: "translate(-3016.192 -1171.346)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7364",
    "data-name": "Grupo 7364",
    transform: "translate(4.427 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2538",
    "data-name": "Trazado 2538",
    d: "M2961.9,1019.523a1.106,1.106,0,0,1-1.1-.962l-3.589-27.107a1.107,1.107,0,0,1,.952-1.242l47.551-6.3a1.107,1.107,0,0,1,1.135,1.592l-7.223,14.465,10.631,11.392a1.107,1.107,0,0,1-.664,1.852l-47.552,6.3A1.075,1.075,0,0,1,2961.9,1019.523Zm-2.346-27.262,3.3,24.913,44.325-5.868-9.689-10.383a1.106,1.106,0,0,1-.181-1.25l6.635-13.288Z",
    transform: "translate(-2957.202 -983.906)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7365",
    "data-name": "Grupo 7365",
    transform: "translate(13.415 4.261)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_263",
    "data-name": "Elipse 263",
    cx: 9.926,
    cy: 9.926,
    r: 9.926,
    transform: "translate(0 14.038) rotate(-45)",
    fill: "#ffd008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7366",
    "data-name": "Grupo 7366",
    transform: "translate(16.805 7.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2539",
    "data-name": "Trazado 2539",
    d: "M3162.31,1125.4a10.648,10.648,0,1,1,10.577-12.047h0a10.66,10.66,0,0,1-9.158,11.953A10.8,10.8,0,0,1,3162.31,1125.4Zm.042-19.857a9.333,9.333,0,0,0-1.228.081,9.168,9.168,0,1,0,1.228-.081Z",
    transform: "translate(-3151.683 -1104.107)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7367",
    "data-name": "Grupo 7367",
    transform: "translate(19.836 12.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2540",
    "data-name": "Trazado 2540",
    d: "M3203.417,1182.636a3.1,3.1,0,0,1-.976.124,3.381,3.381,0,0,1-.992-.213,3.544,3.544,0,0,1-.9-.525,3.821,3.821,0,0,1-.7-.79,3.9,3.9,0,0,1-.427-.982,3.706,3.706,0,0,1-.114-1.073,3.8,3.8,0,0,1,.221-1.061,4.03,4.03,0,0,1,.533-.943,3.537,3.537,0,0,1,3.849-1.21,3.287,3.287,0,0,1,2.135,2.063,3.21,3.21,0,0,1,.162.962,3.268,3.268,0,0,0-2.466-2.4,3.1,3.1,0,0,0-1.672.13,3.059,3.059,0,0,0-1.313.985,3.01,3.01,0,0,0-.253,3.145,3.258,3.258,0,0,0,.483.7,3.7,3.7,0,0,0,.673.559,3.641,3.641,0,0,0,.824.369A4.15,4.15,0,0,0,3203.417,1182.636Z",
    transform: "translate(-3199.308 -1175.798)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7368",
    "data-name": "Grupo 7368",
    transform: "translate(31.773 15.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2541",
    "data-name": "Trazado 2541",
    d: "M3386.923,1233.792a1.512,1.512,0,0,1,.663-1.683,1.676,1.676,0,0,1,2.486,1.917,1.535,1.535,0,0,1-1.428,1.085,1.543,1.543,0,0,0,1.132-1.164,1.462,1.462,0,0,0-.062-.789,1.446,1.446,0,0,0-.465-.62,1.416,1.416,0,0,0-1.484-.119A1.574,1.574,0,0,0,3386.923,1233.792Z",
    transform: "translate(-3386.862 -1231.854)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7369",
    "data-name": "Grupo 7369",
    transform: "translate(25.786 22.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2542",
    "data-name": "Trazado 2542",
    d: "M3296.317,1337.373a1.9,1.9,0,0,1,.486,2.216,2.1,2.1,0,0,1-3.93-.26,1.925,1.925,0,0,1,.729-2.128,1.935,1.935,0,0,0-.365,2,1.837,1.837,0,0,0,.615.779,1.815,1.815,0,0,0,.917.321,1.776,1.776,0,0,0,1.629-.913A1.974,1.974,0,0,0,3296.317,1337.373Z",
    transform: "translate(-3292.792 -1337.202)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7377",
    "data-name": "Grupo 7377",
    transform: "translate(601.985 874.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7371",
    "data-name": "Grupo 7371",
    transform: "translate(1.107 1.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2543",
    "data-name": "Trazado 2543",
    d: "M2952.253,1770.845s-3.3-3,.813-6.3,11.841-1.931,10.418,4.116a4.551,4.551,0,0,1,.458,5.793,3.933,3.933,0,0,1-.1,4.98s1.982,5.031-3.913,5.387-7.928-1.931-6.556-5.946a3.746,3.746,0,0,1-.838-3.837A3.508,3.508,0,0,1,2952.253,1770.845Z",
    transform: "translate(-2950.999 -1762.793)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7372",
    "data-name": "Grupo 7372",
    transform: "translate(1.107 1.106)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2544",
    "data-name": "Trazado 2544",
    d: "M2958.43,1779.833a3.747,3.747,0,0,1-.838-3.837,3.508,3.508,0,0,1-.279-4.193s-3.3-3,.813-6.3a8.16,8.16,0,0,1,3.8-1.639c-2.272-1.613-6.279-1.384-8.864.69-4.116,3.3-.813,6.3-.813,6.3a3.509,3.509,0,0,0,.279,4.193,3.746,3.746,0,0,0,.838,3.837c-1.338,3.916.565,6.187,6.129,5.966C2957.976,1783.855,2957.646,1782.126,2958.43,1779.833Z",
    transform: "translate(-2950.999 -1762.803)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7373",
    "data-name": "Grupo 7373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2545",
    "data-name": "Trazado 2545",
    d: "M2942.507,1769.7c-2.934,0-4.972-.726-6.068-2.165a5.139,5.139,0,0,1-.584-4.677,4.815,4.815,0,0,1-.812-3.844,4.535,4.535,0,0,1-.376-4.247,4.979,4.979,0,0,1-1.055-3.1,5.733,5.733,0,0,1,2.479-4.248c2.807-2.253,7.169-2.652,9.932-.909a5.271,5.271,0,0,1,2.368,5.573,5.56,5.56,0,0,1,.573,6.1,4.885,4.885,0,0,1-.181,5.229,5.285,5.285,0,0,1-.472,4.048c-.85,1.333-2.4,2.076-4.6,2.209Q2943.085,1769.7,2942.507,1769.7Zm-.562-22.071a7.3,7.3,0,0,0-4.469,1.515,3.693,3.693,0,0,0-1.651,2.572,3.013,3.013,0,0,0,.9,2.052,1.118,1.118,0,0,1,.224,1.34,2.412,2.412,0,0,0,.088,2.884,1.107,1.107,0,0,1,.271,1.122,2.611,2.611,0,0,0,.535,2.683,1.107,1.107,0,0,1,.3,1.172c-.491,1.438-.469,2.523.064,3.224.744.977,2.654,1.425,5.377,1.259,1.455-.088,2.419-.488,2.866-1.189a3.528,3.528,0,0,0,.083-2.687,1.108,1.108,0,0,1,.2-1.143,2.784,2.784,0,0,0,.052-3.566,1.116,1.116,0,0,1-.034-1.307,3.4,3.4,0,0,0-.336-4.386,1.121,1.121,0,0,1-.289-1.031,3.17,3.17,0,0,0-1.282-3.763A5.453,5.453,0,0,0,2941.945,1747.628Z",
    transform: "translate(-2933.609 -1745.425)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7374",
    "data-name": "Grupo 7374",
    transform: "translate(2.087 6.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2546",
    "data-name": "Trazado 2546",
    d: "M2970.407,1847.244a16.174,16.174,0,0,1-4-.522l.546-2.145c6.5,1.655,10.027-1.749,10.174-1.895l1.571,1.559A12.032,12.032,0,0,1,2970.407,1847.244Z",
    transform: "translate(-2966.407 -1842.682)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7375",
    "data-name": "Grupo 7375",
    transform: "translate(2.056 11.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2547",
    "data-name": "Trazado 2547",
    d: "M2971.6,1936.274a10.617,10.617,0,0,1-5.682-1.673l1.168-1.88c5.158,3.2,9.949-.369,10.151-.522l1.35,1.754A12.368,12.368,0,0,1,2971.6,1936.274Z",
    transform: "translate(-2965.917 -1932.199)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7376",
    "data-name": "Grupo 7376",
    transform: "translate(2.819 16.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2548",
    "data-name": "Trazado 2548",
    d: "M2984.289,2005.567a10.6,10.6,0,0,1-6.38-2.3l1.318-1.778c5.087,3.772,8.944.726,9.106.594l1.412,1.7A9.241,9.241,0,0,1,2984.289,2005.567Z",
    transform: "translate(-2977.909 -2001.486)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7381",
    "data-name": "Grupo 7381",
    transform: "translate(500.994 900.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7378",
    "data-name": "Grupo 7378",
    transform: "translate(1.105 1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2549",
    "data-name": "Trazado 2549",
    d: "M1371.33,2179.325s-2.191-.7-4.565-1.292a3.533,3.533,0,0,1-2.368-4.513c.009-.029.019-.058.029-.087a3.217,3.217,0,0,1,3.6-2.184,31.585,31.585,0,0,1,5.516,1.489S1376.866,2177.89,1371.33,2179.325Z",
    transform: "translate(-1364.223 -2171.198)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7379",
    "data-name": "Grupo 7379",
    transform: "translate(1.105 2.632)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2550",
    "data-name": "Trazado 2550",
    d: "M1371.646,2198.6s-2.191-.7-4.565-1.293a3.375,3.375,0,0,1-2.314-2.148,3.415,3.415,0,0,0-.342.71c-.01.029-.02.058-.029.087a3.533,3.533,0,0,0,2.368,4.513c2.375.593,4.565,1.292,4.565,1.292,3.4-.882,3.458-3.165,3-4.8A4.407,4.407,0,0,1,1371.646,2198.6Z",
    transform: "translate(-1364.223 -2195.157)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7380",
    "data-name": "Grupo 7380",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2551",
    "data-name": "Trazado 2551",
    d: "M1355.069,2164.143a1.1,1.1,0,0,1-.337-.052c-.022-.007-2.187-.7-4.5-1.273a4.452,4.452,0,0,1-2.783-2.174,4.753,4.753,0,0,1-.37-3.753l.034-.1a4.313,4.313,0,0,1,4.851-2.918,32.53,32.53,0,0,1,5.721,1.547,1.111,1.111,0,0,1,.526.43c.19.294,1.824,2.942.873,5.378a5.015,5.015,0,0,1-3.74,2.881A1.1,1.1,0,0,1,1355.069,2164.143Zm-3.864-8.128a2.136,2.136,0,0,0-1.994,1.488l-.022.067a2.533,2.533,0,0,0,.2,2,2.2,2.2,0,0,0,1.385,1.1c1.876.469,3.616.995,4.314,1.212a2.768,2.768,0,0,0,1.938-1.46,4.2,4.2,0,0,0-.5-3.078,31.437,31.437,0,0,0-4.956-1.295A1.988,1.988,0,0,0,1351.206,2156.015Z",
    transform: "translate(-1346.856 -2153.801)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7393",
    "data-name": "Grupo 7393",
    transform: "translate(506.244 895.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7382",
    "data-name": "Grupo 7382",
    transform: "translate(1.106 1.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2552",
    "data-name": "Trazado 2552",
    d: "M1490.665,2103.68c-4.506,9.417-9.455,19.75-9.455,19.75-11.077-6.4-33.4-11.958-33.4-11.958l-1.085-3.931a87.613,87.613,0,0,1,7.1-20.243c11.361.547,22.109,4.686,28.762,7.826a74.776,74.776,0,0,1,6.827,3.608Z",
    transform: "translate(-1446.722 -2087.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7383",
    "data-name": "Grupo 7383",
    transform: "translate(1.106 8.931)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2553",
    "data-name": "Trazado 2553",
    d: "M1490.665,2218.815c-4.506,9.417-9.455,19.75-9.455,19.75-11.077-6.4-33.4-11.958-33.4-11.958l-1.085-3.93s33.337,9.881,35.86-12.417a74.883,74.883,0,0,1,6.827,3.608Z",
    transform: "translate(-1446.722 -2210.259)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7384",
    "data-name": "Grupo 7384",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2554",
    "data-name": "Trazado 2554",
    d: "M1464.937,2108.274a1.106,1.106,0,0,1-.554-.149c-10.818-6.253-32.9-11.788-33.118-11.843a1.106,1.106,0,0,1-.8-.78l-1.084-3.93a1.1,1.1,0,0,1-.02-.5,87.637,87.637,0,0,1,7.2-20.538,1.113,1.113,0,0,1,1.038-.6c18.688.9,35.417,11.163,36.12,11.6a1.109,1.109,0,0,1,.489.668l1.254,4.947a1.105,1.105,0,0,1-.074.749c-4.506,9.418-9.452,19.752-9.452,19.752a1.106,1.106,0,0,1-1,.629Zm-32.509-13.98c3.653.937,21.634,5.7,32.02,11.333,1.353-2.827,5.179-10.82,8.77-18.326l-1.043-4.115c-2.551-1.5-17.637-9.991-33.96-11a86.593,86.593,0,0,0-6.63,19.054Z",
    transform: "translate(-1429.341 -2069.928)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7392",
    "data-name": "Grupo 7392",
    transform: "translate(0.879 1.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7385",
    "data-name": "Grupo 7385",
    transform: "translate(19.988 6.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_481",
    "data-name": "Rect\\xE1ngulo 481",
    width: 5.183,
    height: 5.183,
    rx: 2.592,
    transform: "matrix(0.94, 0.341, -0.341, 0.94, 1.77, 0)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7386",
    "data-name": "Grupo 7386",
    transform: "translate(27.527 9.437)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_482",
    "data-name": "Rect\\xE1ngulo 482",
    width: 5.183,
    height: 5.183,
    rx: 2.592,
    transform: "translate(1.77 0) rotate(19.963)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7387",
    "data-name": "Grupo 7387",
    transform: "translate(17.244 13.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_483",
    "data-name": "Rect\\xE1ngulo 483",
    width: 5.183,
    height: 5.183,
    rx: 2.592,
    transform: "matrix(0.94, 0.341, -0.341, 0.94, 1.77, 0)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7388",
    "data-name": "Grupo 7388",
    transform: "translate(24.783 16.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_484",
    "data-name": "Rect\\xE1ngulo 484",
    width: 5.183,
    height: 5.183,
    rx: 2.592,
    transform: "translate(1.77 0) rotate(19.963)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7389",
    "data-name": "Grupo 7389",
    transform: "translate(0 10.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2555",
    "data-name": "Trazado 2555",
    d: "M1476.377,2280.667a1.106,1.106,0,0,1-.542-.142c-11.777-6.616-32.476-11.019-32.684-11.062l.455-2.166c.837.177,20.1,4.275,32.267,10.728,1.424-3.035,5.628-11.936,9.207-18.956l1.972,1.005c-4.344,8.522-9.619,19.84-9.672,19.953a1.108,1.108,0,0,1-1,.64Z",
    transform: "translate(-1443.151 -2259.069)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7390",
    "data-name": "Grupo 7390",
    transform: "translate(32.176 31.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_485",
    "data-name": "Rect\\xE1ngulo 485",
    width: 2.214,
    height: 4.682,
    transform: "matrix(0.948, -0.318, 0.318, 0.948, 0, 0.705)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7391",
    "data-name": "Grupo 7391",
    transform: "translate(8.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2556",
    "data-name": "Trazado 2556",
    d: "M1571.758,2112.309l-2.1-.693,3.319-10.058-2.52-.588a1.107,1.107,0,0,1-.784-1.467l3.7-9.827,2.072.78-3.254,8.646,2.469.577a1.107,1.107,0,0,1,.8,1.425Z",
    transform: "translate(-1569.6 -2089.675)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7397",
    "data-name": "Grupo 7397",
    transform: "translate(544.767 916.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7394",
    "data-name": "Grupo 7394",
    transform: "translate(1.107 1.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2557",
    "data-name": "Trazado 2557",
    d: "M2052.881,2430.745a50.659,50.659,0,0,1,12.657,10.161,3.41,3.41,0,0,0,5.429-.531l.069-.118a3.418,3.418,0,0,0-.405-3.957,57.122,57.122,0,0,0-14.847-12.121,1.558,1.558,0,0,0-1.193-.114c-1.1.337-3.015,1.5-2.512,5.494A1.562,1.562,0,0,0,2052.881,2430.745Z",
    transform: "translate(-2051.995 -2423.995)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7395",
    "data-name": "Grupo 7395",
    transform: "translate(1.107 2.628)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2558",
    "data-name": "Trazado 2558",
    d: "M2066.174,2459.507a50.651,50.651,0,0,0-12.657-10.161,1.564,1.564,0,0,1-.8-1.186c-.011-.086-.014-.163-.023-.247a6.005,6.005,0,0,0-.61,4.041,1.563,1.563,0,0,0,.8,1.186,50.659,50.659,0,0,1,12.657,10.161,3.41,3.41,0,0,0,5.429-.53l.069-.118a3.41,3.41,0,0,0,.139-3.114A3.421,3.421,0,0,1,2066.174,2459.507Z",
    transform: "translate(-2051.999 -2447.913)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7396",
    "data-name": "Grupo 7396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2559",
    "data-name": "Trazado 2559",
    d: "M2051.769,2426.856a4.5,4.5,0,0,1-3.33-1.464,49.311,49.311,0,0,0-12.367-9.936h0a2.676,2.676,0,0,1-1.377-2.022c-.621-4.939,2.091-6.324,3.286-6.69a2.682,2.682,0,0,1,2.043.2,57.943,57.943,0,0,1,15.153,12.365,4.521,4.521,0,0,1,.535,5.239l-.076.131a4.416,4.416,0,0,1-3.373,2.155A4.788,4.788,0,0,1,2051.769,2426.856Zm-14.648-13.349a51.591,51.591,0,0,1,12.947,10.386,2.308,2.308,0,0,0,1.962.736,2.223,2.223,0,0,0,1.7-1.08l.06-.1a2.309,2.309,0,0,0-.275-2.677,55.683,55.683,0,0,0-14.541-11.879.45.45,0,0,0-.345-.03c-1.435.44-2.037,1.926-1.738,4.3a.459.459,0,0,0,.23.35Z",
    transform: "translate(-2034.603 -2406.626)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6201",
    "data-name": "Grupo 6201",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 340.279, 55.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8127",
    "data-name": "Grupo 8127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3109",
    "data-name": "Trazado 3109",
    d: "M31.917,197.527l-1.269,2.22,3.579,2.046-1.179,2.062-3.579-2.045-1.376,2.406,4.048,2.313-1.224,2.142-6.72-3.842,6.272-10.97,6.719,3.842-1.224,2.141Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3110",
    "data-name": "Trazado 3110",
    d: "M35.366,210.491a4.055,4.055,0,0,1-1.05-1.937,3.641,3.641,0,0,1,.245-2.221l2.984,1.351a1.588,1.588,0,0,0,0,1.175,1.57,1.57,0,0,0,.832.783,1.7,1.7,0,0,0,1.114.158,1.053,1.053,0,0,0,.721-.633,1.037,1.037,0,0,0,.032-.835,2.553,2.553,0,0,0-.5-.778,12.847,12.847,0,0,0-1-.948,14.163,14.163,0,0,1-1.508-1.512,3.7,3.7,0,0,1-.754-1.567,3.106,3.106,0,0,1,.286-1.984,3.312,3.312,0,0,1,2.3-1.99,5.244,5.244,0,0,1,3.446.463,5.312,5.312,0,0,1,2.654,2.3,3.576,3.576,0,0,1,.1,3.1l-3.033-1.373a1.3,1.3,0,0,0-.013-1.062,1.58,1.58,0,0,0-.823-.758,1.317,1.317,0,0,0-.942-.1,1.067,1.067,0,0,0-.664.638,1.056,1.056,0,0,0,.131,1.106,9.389,9.389,0,0,0,1.336,1.415,16.879,16.879,0,0,1,1.485,1.541,3.808,3.808,0,0,1,.753,1.546,2.94,2.94,0,0,1-.256,1.92,3.651,3.651,0,0,1-1.309,1.561,3.838,3.838,0,0,1-2.031.622,5.466,5.466,0,0,1-2.462-.541A6.522,6.522,0,0,1,35.366,210.491Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3111",
    "data-name": "Trazado 3111",
    d: "M54.912,211.358a3.706,3.706,0,0,1-1.935.9,5.448,5.448,0,0,1-2.635-.3l-1.808-.607-1.445,4.3-2.918-.98L48.2,202.692l4.726,1.589a5.68,5.68,0,0,1,2.257,1.31,3.6,3.6,0,0,1,1.026,1.863,4.189,4.189,0,0,1-.177,2.163A4.06,4.06,0,0,1,54.912,211.358Zm-2.634-1.767a1.8,1.8,0,0,0,.746-2.219,1.836,1.836,0,0,0-1.114-.81l-1.587-.535-1.009,3,1.587.534A1.837,1.837,0,0,0,52.278,209.591Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3112",
    "data-name": "Trazado 3112",
    d: "M60.887,209.114l-.582,2.49,4.014.938-.542,2.313-4.013-.938-.632,2.7,4.54,1.062-.562,2.4-7.537-1.764,2.879-12.3,7.536,1.763-.561,2.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3113",
    "data-name": "Trazado 3113",
    d: "M67.34,211.1a5.794,5.794,0,0,1,2.526-1.988,6.559,6.559,0,0,1,3.362-.4,6.3,6.3,0,0,1,3.674,1.658,5.709,5.709,0,0,1,1.722,3.482l-3.358-.421a2.741,2.741,0,0,0-.912-1.33,3.013,3.013,0,0,0-1.512-.607,2.939,2.939,0,0,0-2.409.7,4.412,4.412,0,0,0-.659,5.251,2.943,2.943,0,0,0,2.164,1.269,3.026,3.026,0,0,0,1.614-.215,2.745,2.745,0,0,0,1.213-1.063l3.357.421a5.661,5.661,0,0,1-2.527,2.939,6.318,6.318,0,0,1-3.969.69,6.56,6.56,0,0,1-3.158-1.221,5.813,5.813,0,0,1-1.958-2.54,7.27,7.27,0,0,1,.83-6.617Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3114",
    "data-name": "Trazado 3114",
    d: "M83.7,209.648l-.5,12.626-3.076-.123.5-12.626Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3115",
    "data-name": "Trazado 3115",
    d: "M93.81,219.865l-4.711.2-.66,2.263-3.219.139,4.023-12.822,3.561-.153,5.113,12.427-3.256.141Zm-.894-2.34-1.764-4.553-1.347,4.688Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3116",
    "data-name": "Trazado 3116",
    d: "M102.756,218.783l3.992-.568.335,2.352-7.04,1-1.778-12.509,3.047-.434Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3117",
    "data-name": "Trazado 3117",
    d: "M109.433,207.165l2.554,12.375-3.014.622-2.555-12.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3118",
    "data-name": "Trazado 3118",
    d: "M116.648,218.1a4.054,4.054,0,0,1-2.052-.8,3.641,3.641,0,0,1-1.248-1.854l3.15-.9a1.592,1.592,0,0,0,.761.9,1.556,1.556,0,0,0,1.14.059,1.688,1.688,0,0,0,.953-.6,1.054,1.054,0,0,0,.141-.948,1.039,1.039,0,0,0-.515-.658,2.533,2.533,0,0,0-.882-.273,12.488,12.488,0,0,0-1.379-.075,14.22,14.22,0,0,1-2.128-.179,3.69,3.69,0,0,1-1.587-.709,3.108,3.108,0,0,1-1.065-1.7,3.31,3.31,0,0,1,.472-3.006,5.252,5.252,0,0,1,2.93-1.874,5.309,5.309,0,0,1,3.511.039,3.573,3.573,0,0,1,2.077,2.3l-3.2.912a1.306,1.306,0,0,0-.7-.8,1.582,1.582,0,0,0-1.117-.047,1.329,1.329,0,0,0-.784.532,1.075,1.075,0,0,0-.1.916,1.06,1.06,0,0,0,.816.76,9.479,9.479,0,0,0,1.933.217,16.786,16.786,0,0,1,2.13.216,3.784,3.784,0,0,1,1.573.694,2.939,2.939,0,0,1,1.044,1.631,3.63,3.63,0,0,1,.01,2.037,3.835,3.835,0,0,1-1.147,1.786,5.462,5.462,0,0,1-2.229,1.178A6.487,6.487,0,0,1,116.648,218.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3119",
    "data-name": "Trazado 3119",
    d: "M129.878,200.495l.9,2.293-3.114,1.23,3.733,9.46-2.863,1.129-3.733-9.46-3.115,1.23-.9-2.294Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3120",
    "data-name": "Trazado 3120",
    d: "M142.619,205.647l-4.173,2.2.37,2.327-2.851,1.5-1.838-13.312,3.153-1.66,9.931,9.054-2.883,1.517Zm-1.807-1.733-3.541-3.364.786,4.814Z",
    fill: "#fff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_551",
    "data-name": "Rect\\xE1ngulo 551",
    width: 248,
    height: 248,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspecialista);
export default __webpack_public_path__ + "static/media/Especialista.c5d166ccede7cc4d0d126696ce0df347.svg";
export { ForwardRef as ReactComponent };